import React from "react";
import { IAutomationMailWorkerEdit } from "../../../interfaces/IAutomationMail";
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, Typography } from "@mui/material";
import { AutomationMailWorkerEditAccordion } from "./AutomationMailWorkerEditAccordion";
import { useSendAutomationEmails } from "../../../hooks/data/data_automation";

interface IProps {
    automationMailWorkerEditArray: IAutomationMailWorkerEdit[];
    setAutomationMailWorkerEditArray: Function;
    setFeedback: Function;
}

export const AutomationMailWorkerEditDialog: React.FC<IProps> = ({
    automationMailWorkerEditArray,
    setAutomationMailWorkerEditArray,
    setFeedback,
}) => {
    const { isPendingSendAutomationEmails, sendAutomationEmails } = useSendAutomationEmails();

    const handleSendMails = async () => {
        try {
            await sendAutomationEmails(automationMailWorkerEditArray);
            setFeedback({ open: true, message: "Die E-Mails wurden erfolgreich versendet!", severity: "success" });
            setAutomationMailWorkerEditArray([]);
        } catch (error) {
            console.error(error);
            setFeedback({ open: true, message: "E-Mails konnten nicht gesendet werden!", severity: "error" });
        }
    };

    if (automationMailWorkerEditArray.length === 0) {
        return <></>;
    }

    return (
        <Dialog open onClose={() => setAutomationMailWorkerEditArray([])} maxWidth="md" fullWidth>
            <DialogContent>
                <>
                    <Typography variant="h5">Automatisierte E-Mails</Typography>
                    <Typography>
                        Nachfolgend finden Sie die E-Mails, die basierend auf der Automatisierung Ihres zuletzt
                        gespeicherten Objekts automatisch versendet werden. Sie haben die Möglichkeit, die Inhalte
                        anzupassen, den Absender zu ändern oder den Versand vollständig zu unterbinden.
                    </Typography>
                    <Box sx={{ mt: 5 }} />
                    {automationMailWorkerEditArray.map((autoMail) => (
                        <AutomationMailWorkerEditAccordion
                            key={`edit-worker-mail-${autoMail.id}`}
                            automationMailWorkerEdit={autoMail}
                            automationMailWorkerEditArray={automationMailWorkerEditArray}
                            setAutomationMailWorkerEditArray={setAutomationMailWorkerEditArray}
                        />
                    ))}
                </>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={() => setAutomationMailWorkerEditArray([])}>
                    Schließen
                </Button>
                <Button variant="contained" disabled={isPendingSendAutomationEmails} onClick={handleSendMails}>
                    {isPendingSendAutomationEmails ? (
                        <Box display="flex" alignItems="center" gap={1}>
                            <span>Senden</span>
                            <CircularProgress size={20} />
                        </Box>
                    ) : (
                        "Senden"
                    )}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
